import React, { useRef, useState } from "react"
import PardanKarmaReport from "./helper/PardanKarmaReport";
import UpakarmaReport from "./helper/UpakarmaReport";
import PurbaPanchaKarmaReport from "./helper/PurbaPanchaKarmaReport";
import MessageBlock from "../../admin/components/message-block/MessageBlock";
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import ReportHeader from "../component/report-header/ReportHeader";
import AddAlertMessage from "../../../components/alert/Alert";
import AHMIS, { API_URL } from "../../../api/api";
import { Box } from "@mui/material";

const PanchaKarmaPurbaKarmaSewaReport = () => {

  const [tableData, setTableData] = useState({});
  const [purbaPanchaKarmaData, setPurbaPanchaKarmaData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.pardanKarmaUpkarmaReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    const urls = `${API_URL.panchakarmaReport}?fromDate=${dateFrom}&toDate=${dateTo}`;

    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });

    AHMIS.get(urls)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setPurbaPanchaKarmaData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader
        title="पञ्चकर्म रिपोर्ट"
        getReportData={getReportData}
        reportData={Boolean(purbaPanchaKarmaData)}
        printComponentRef={printComponentRef}
      />
      {Object.keys(tableData).length > 0 ? (
        <>
          <Box ref={printComponentRef}>
            <PardanKarmaReport tableData={tableData} />
            <UpakarmaReport tableData={tableData} />
            <PurbaPanchaKarmaReport tableData={purbaPanchaKarmaData} />
          </Box>
        </>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  );
};
export default PanchaKarmaPurbaKarmaSewaReport;